"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.SocialItemLink = exports.SocialList = exports.SocialLabel = exports.SocialWrapper = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _Link = _interopRequireDefault(require("../Link"));

var SocialWrapper = (0, _styled.default)('div')({
  display: 'inline-block'
});
exports.SocialWrapper = SocialWrapper;
var SocialLabel = (0, _styled.default)('div')(function (_ref) {
  var space = _ref.theme.space;
  return {
    marginRight: space.base
  };
});
exports.SocialLabel = SocialLabel;
var SocialList = (0, _styled.default)('div')({
  display: 'flex',
  alignItems: 'center'
});
exports.SocialList = SocialList;
var SocialItemLink = (0, _styled.default)(_Link.default)(function (_ref2) {
  var space = _ref2.theme.space;
  return {
    display: 'flex',
    marginLeft: space.small,
    '&:first-of-type': {
      marginLeft: '0'
    }
  };
});
exports.SocialItemLink = SocialItemLink;